{
  "support": {
    "reachOut": "Please reach out to the person who invited you or contact support."
  },
  "accept": {
    "pending": {
      "heading": "Accepting Invite"
    },
    "accepted": {
      "heading": "You've accepted the invite!",
      "body": "For security reasons, we need you to login before accessing the platform."
    },
    "alreadyAccepted": {
      "heading": "Invite already accepted",
      "body": "You already accepted this invite.",
      "redirect": {
        "login": "We'll redirect you to the login page.",
        "venueGroup": "We'll redirect you to the Hospitality Group Page."
      }
    },
    "error": {
      "body": "An error occurred accepting your invite."
    },
    "notifications": {
      "failed": {
        "title": "Failed to accept invite"
      }
    }
  },
  "join": {
    "heading": {
      "withTier": "{{venueGroupName}} has invited you to join Ande as a {{tier}} partner.",
      "withoutTier": "{{venueGroupName}} has invited you to join Ande."
    },
    "subheading": "Set up your account to access the platform",
    "error": {
      "body": "An error occurred with this referral link."
    },
    "form": {
      "phoneNumber": {
        "description": "By providing your mobile number, you agree that it may be used to send you text messages and call you to confirm and manage your reservations."
      },
      "diningFrequency": {
        "label": "How often do you organize dinner and events?",
        "placeholder": "Select an option",
        "options": {
          "atLeastThreePerWeek": "3+ per week",
          "oncePerWeek": "1 per week",
          "oncePerMonth": "1 per month",
          "oncePerQuarter": "1 per quarter"
        }
      },
      "policies": {
        "attest": "I attest that this information is accurate and that I have read and agree to the <privacyPolicy>Privacy Policy</privacyPolicy> and <termsOfService>Terms of Service</termsOfService>"
      },
      "rewards": {
        "optionalLabel": "(Optional)",
        "optIn": "Enable Ande Rewards for my account. <rewardsTerms>Read Terms & Conditions</rewardsTerms>"
      },
      "submit": {
        "label": "Sign Up",
        "submitting": "Setting Up Account..."
      },
      "verifyNotice": "We will ask you to log in to verify your account"
    },
    "notifications": {
      "accountCreated": {
        "title": "Success",
        "body": "Your account has been created."
      },
      "accountFailed": {
        "title": "Error",
        "body": "There was an error creating your account. Please try again."
      },
      "createFailed": "Failed to create account",
      "inviteAccepted": {
        "title": "Invite Accepted",
        "body": "You've accepted the invite from {{venueGroupName}}"
      },
      "inviteAlreadyAccepted": {
        "title": "Invite Already Accepted",
        "body": "You've already accepted the invite from {{venueGroupName}}"
      },
      "acceptFailed": {
        "body": "There was an error accepting the invite. Please try again."
      }
    }
  }
}
